/* eslint-disable no-console */
import React, { useContext, useState } from 'react';
import { Avatar, Grid, Stack, Typography, Box, Button } from '@mui/material';
import { MdMoreVert } from 'react-icons/md';
import NewDialogPopup from '../../../../../../../components/Common/NewDialogPopup/NewDialogPopup';
import { LanguageContext } from '../../../../../../../libs/Context';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import SpeakerDetailsPopup from './SpeakerDetailsView';
import { Add } from '@mui/icons-material';
import { deleteSpeakerFunc } from '../../../../../../actions/meeting_actions';
import { toast } from 'react-toastify';
import Loading from '../../../../../../../components/Common/Loaders/FullWidthLoader/Loading';
const SpeakersCards = (props) =>
{
	const { handleAddSpeaker, item, setDelGetApi } = props;
	const { linkedinUrl, facebookUrl, twitterUrl, websiteUrl } = item;
	const [ loading, setLoading ] = useState(false);
	const [ delSpeakers, setDelSpeakers ] = useState({
		open : false,
		id   : ''
	});
	const [ speakerDetail, setSpeakerDetail ] = useState({
		open    : false,
		details : {}
	});

	const { language } = useContext(LanguageContext);
	const [ anchorEl, setAnchorEl ] = useState({
		open    : null,
		details : {}
	});
	const open = Boolean(anchorEl?.open);

	const handleClick = (event, speaker) =>
	{
		setAnchorEl({
			open    : event.currentTarget,
			details : speaker
		});
		event.stopPropagation();
	};
	const handleViewDetails = (event, details) =>
	{
		setSpeakerDetail({
			open : true,
			details
		});
	};
	const handleClose = () =>
	{
		setAnchorEl((prev) => ({
			...prev,
			open : null
		}));
	};
	const handleDeleteSpeakers = (e, id) =>
	{
		setDelSpeakers({
			open : true,
			id
		});
		handleClose();
	};

	const handleDelSpeaker = async () =>
	{
		try
		{
			const query = {
				id : delSpeakers?.id
			};

			setLoading(true);
			const res = await deleteSpeakerFunc(query);

			if (res?.status)
			{
				toast.success('Speaker Deleted Successfully', {
					position : toast.POSITION.TOP_RIGHT
				});
				setLoading(false);
				setDelSpeakers((prev) => ({
					...prev,
					open : false
				}));
				setDelGetApi(true);
			}
			else
			{
				setLoading(false);
			}
		}
		catch (error:any)
		{
			setDelSpeakers((prev) => ({
				...prev,
				open : false
			}));
			toast.success(error?.response?.data?.message, {
				position : toast.POSITION.TOP_RIGHT
			});
			setLoading(false);
		}
	};

	const checkSocailMedia = linkedinUrl === '' && facebookUrl === '' && twitterUrl === '' && websiteUrl === '';
	const organisationName = item?.organization ? ` at ${item?.organization}` : '';

	return (
		<>
			{loading && <Loading />}
			<Grid item xs={12} sm={6} md={4} position={'relative'} mt={2} onClick={(e) => handleViewDetails(e, item)} sx={{ cursor: 'pointer' }}>
				<Stack direction={'column'} border={'1px solid rgba(224, 224, 224, 1)'} borderRadius={'var(--pixel8)'} p='var(--pixel16)' height={'var(--percent100)'}>
					<Stack alignItems='flex-end' sx={{ cursor: 'pointer' }} onClick={(e) => handleClick(e, item)}>
						<MdMoreVert fontSize='var(--pixel20)'/>
					</Stack>
					<Typography variant='subtitle1' fontWeight='var(--font500)' sx={{ overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis', width: 'var(--percent100)' }}>{item?.speakerName}</Typography>
					<Typography variant='subtitle1' fontWeight='var(--font500)' sx={{ overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis', width: 'var(--percent100)' }}>{item?.designation ? `${item?.designation}${organisationName}` : ''}</Typography>
					<Typography variant='body2' sx={{ overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis', width: 'var(--percent100)' }}>{item?.speakerEmail}</Typography>
					<Stack pt='var(--pixel16)' direction={'row'} spacing={2}>
						{item?.linkedinUrl && <Box sx={{ width: 'var(--pixel28)', height: 'var(--pixel28)' }}><img src='/images/logos/webLink.svg' alt='' style={{ width: 'var(--percent100)', height: 'var(--percent100)', objectFit: 'cover' }} /></Box>}
						{item?.facebookUrl && <Box sx={{ width: 'var(--pixel28)', height: 'var(--pixel28)' }}><img src='/images/icons/facebook.svg' alt='' style={{ width: 'var(--percent100)', height: 'var(--percent100)' }} /></Box>}
						{item?.twitterUrl && <Box sx={{ width: 'var(--pixel28)', height: 'var(--pixel28)' }}><img src='/images/logos/webTwitt.svg' alt='' style={{ width: 'var(--percent100)', height: 'var(--percent100)' }} /></Box>}

					</Stack>
					{checkSocailMedia && <Button size='small' variant='text' onClick={(e) =>
					{
						e.stopPropagation();
						handleAddSpeaker(e, item);
					}} startIcon={<Add/>}>Social Media</Button>}
				</Stack>
				<Stack position={'absolute'} top={-8} left={'var(--pixel30)'}>
					<Avatar sx={{ width: '50px', height: '50px' }} src={item?.speakerImage?.url} />
				</Stack>
			</Grid>
			<Menu
				id='basic-menu'
				anchorEl={anchorEl?.open}
				open={open}
				onClose={handleClose}
				MenuListProps={{
					'aria-labelledby' : 'basic-button'
				}}
				anchorOrigin={{ vertical: 20, horizontal: 'right' }}
				transformOrigin={{ vertical: 'top', horizontal: 60 }}
			>
				<MenuItem onClick={(e) =>
				{ handleAddSpeaker(e, anchorEl?.details); handleClose(); }}
				>{language?.edit}</MenuItem>
				<MenuItem onClick={(e) => handleDeleteSpeakers(e, item?._id)}>
					{language?.delete}</MenuItem>
			</Menu>
			{delSpeakers?.open &&
			<NewDialogPopup
				open={delSpeakers?.open}
				handleConfirm={handleDelSpeaker}
				type='Yes'
				id={undefined}
				label={language.deleteSpeakerAlert}
				from='feedCreate'
				formatType='No'
			/>
			}
			{speakerDetail?.open &&
			<SpeakerDetailsPopup
				open={speakerDetail?.open}
				details={speakerDetail?.details}
				setOpen={setSpeakerDetail}
				handleAddSpeaker={handleAddSpeaker}
			/>}
		</>
	);
};

export default SpeakersCards;
